import { render, staticRenderFns } from "./MessageRow.vue?vue&type=template&id=3d25db02&"
import script from "./MessageRow.ts?vue&type=script&lang=ts&"
export * from "./MessageRow.ts?vue&type=script&lang=ts&"
import style0 from "./MessageRow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports